import { atom, useAtom, useSetAtom } from "jotai";

const posTakeoutAtom = atom(false);

const usePosTakeout = () => {
  const atom = useAtom(posTakeoutAtom);
  return atom;
};

export const useSetPosTakeout = () => useSetAtom(posTakeoutAtom);

export default usePosTakeout;
